var React = require("react");

module.exports = function DropdownOptions(props) {
	return (
		<option value={props.value}>{props.text}</option>
	);

};
